'use strict';
import { EwSiteApp } from '../../app/ewsiteapp';

export function ProjectsMap(params) {
	if (typeof (params.default_coordinates.lat) !== 'number' && typeof (params.default_coordinates.lng) !== 'number') {
		console.log('no default coordinates');
		return false;
	}

	if (typeof (params.data_url) !== 'string' || params.data_url == '') {
		console.log('no data_url');
		return false;
	}

	var innerPrivate = {
		map: {},
		markers: [],
		items: [],
		infowindow: null
	};

	var poiStyles = [
		{
			featureType: "poi",
			elementType: "labels",
			stylers: [
				{visibility: "off"}
			]
		}
	];

	innerPrivate.init = function () {
		innerPrivate.map = new google.maps.Map(document.getElementById('projectsmap'), {
			zoom: params.zoom,
			center: params.default_coordinates,
			gestureHandling: 'cooperative',
			scaleControl: false,
			fullscreenControl: false,
			mapTypeControl: false,
			styles: poiStyles
		});
		var show_all_cats = true;

		innerPrivate.getProblemList();
		innerPrivate.initKml();

		$('#radios_select .one_filter_cat:not(#clear_projects_map)').on('click keydown', function (e) {
			if(e.type == 'click' || e.keyCode == 13) {
				if (show_all_cats || !$(this).hasClass("active")) {
					$('#radios_select .one_filter_cat').removeClass("active");
					$(this).addClass("active");
					innerPrivate.showMarkersByType($(this).data("id"));
					innerPrivate.showKmlByCat($(this).data("kml"));
					show_all_cats = false;
				} else {
					$('#clear_projects_map').trigger("click");
					innerPrivate.showKmlByCat('');
				}
			}
		});

		$('#clear_projects_map').on('click keydown', function (e) {
			if (e.type == 'click' || e.keyCode == 13) {
				$('#radios_select .one_filter_cat').removeClass("active");
				innerPrivate.showMarkersByType(0); // Show all markers
				innerPrivate.showKmlByCat('');
				innerPrivate.initKml();
				show_all_cats = true;
			}
		});


		$('.sidebar_close').on('click keydown', function (e) {
			if(e.type == 'click' || e.keyCode == 13) {
				$(".shadow_overlay").fadeOut("fast");
				$(".map_sidebar").removeClass("visible");
			}
		});
		$('.shadow_overlay').on('click keydown', function (e) {
			if(e.type == 'click' || e.keyCode == 13) {
				$('.sidebar_close').trigger("click");
			}
		});
	};

	innerPrivate.initKml = function () {
		var kml_file_url = $("#projectsmap").data("kml");
		if (kml_file_url) {
			innerPrivate.kmlLayer = new google.maps.KmlLayer(kml_file_url, {
				map: innerPrivate.map
			});
		}
	};

	innerPrivate.getProblemList = function () {
		$.ajax({
			url: params.data_url,
			dataType: 'json',
			success: function (resp) {
				if (resp.success) {
					innerPrivate.items = resp.data;
					innerPrivate.showProblems();
				}
			},
			error: function () {
				alert('Load error.');
			}
		});
	};

innerPrivate.showProblems = function () {
    var $map = $("#projectsmap");
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0, l = innerPrivate.items.length; i < l; i++) {
        (function () { // Create a closure to preserve the value of 'infowindow' for each iteration
            var item = innerPrivate.items[i];
            var id = parseInt(item.id);
            var point = new google.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng));

            var marker = new google.maps.Marker({
                id: i,
                problem_id: id,
                position: point,
                map: innerPrivate.map,
                title: item.title,
                icon: {
                    url: $map.data("themedir") + 'img/projectsmap/maplogo_' + item.color + '.png',
                    scaledSize: new google.maps.Size(30, 34)
                },
                problem_category_id: parseInt(item.category_id)
            });

            // Create content for the InfoWindow
            var content = innerPrivate.getProblemHtml(item);

            // Attach click event listener to marker to display InfoWindow
            marker.addListener('click', function () {
                // Close any open InfoWindow
                innerPrivate.closeInfoWindows();

                // Create a new InfoWindow object
                var infowindow = new google.maps.InfoWindow({
                    content: content
                });

                // Open InfoWindow for this marker
                infowindow.open(innerPrivate.map, marker);

                // Store the InfoWindow object in the innerPrivate object
                innerPrivate.infowindow = infowindow;
            });

            innerPrivate.markers.push(marker); // Store marker in markers array
            bounds.extend(point);
        })();
    }
    if (window.location.hash) {
        var project_id = parseInt(100000000000000) + parseInt(window.location.hash.substr(8));
        for (var p = 0; p < innerPrivate.items.length; p++) {
            if (innerPrivate.items[p].id == project_id && typeof (innerPrivate.items[p].lat2) === 'number') {
                project_id = parseInt(200000000000000) + parseInt(window.location.hash.substr(8));
            }
            if (innerPrivate.items[p].id == project_id) {
                innerPrivate.showInfoSidebar(innerPrivate.items[p]);
                break;
            }

        }
    }
    innerPrivate.map.fitBounds(bounds);
};

	innerPrivate.showInfoSidebar = function (item) {
		if (item) {
			var $sidebar = $(".map_sidebar");
			$(".shadow_overlay").fadeIn("fast");
			$sidebar.addClass("visible");
			$('html, body').animate({
				scrollTop: $(".projectsmap_parent").offset().top - 237
			}, 300);

			$(".catimg", $sidebar).attr("src", item.cat_imgurl);
			$(".h_title", $sidebar).html(item.category_title).attr('class', 'h_title ' + item.color + '');
			$(".project_title", $sidebar).html(item.title);
			$(".q_left .meta_value", $sidebar).html(item.value);
			$(".q_right .meta_value", $sidebar).html(item.date_text);
			$(".project_formatted", $sidebar).html(item.description);

			// From Tinymce
			$("a[rel=fancybox]").fancybox({
				helpers: {
					overlay: {
						locked: false
					}
				},
				btnTpl: {
					zoom: false
				}
			});
		}
	};

	innerPrivate.showMarkersByType = function (category_id) {
		category_id = parseInt(category_id) || 0;

		innerPrivate.closeInfoWindows();

		var visibleMarkers = [];
		var bounds = new google.maps.LatLngBounds();

		for (var i = 0; i < innerPrivate.markers.length; i++) {
			var marker = innerPrivate.markers[i];
			var position = marker.getPosition();

			if (category_id === 0 || category_id === marker.problem_category_id) {
				if (position && isFinite(position.lat()) && isFinite(position.lng())) {
					marker.setVisible(true);
					visibleMarkers.push(marker);
					bounds.extend(position);
				} else {
					console.warn('Skipping marker due to invalid position:', marker, position);
					marker.setVisible(false);
				}
			} else {
				marker.setVisible(false);
			}
		}

		if (visibleMarkers.length > 0) {
			innerPrivate.map.fitBounds(bounds);

			google.maps.event.addListenerOnce(innerPrivate.map, 'idle', function() {
				if (innerPrivate.map.getZoom() > 15) {
					innerPrivate.map.setZoom(15);
				}
			});
		} else {
			console.log('No valid visible markers to center on.');
		}
	};




	innerPrivate.showKmlByCat = function (file_url) {
		if (typeof (innerPrivate.kmlLayer) !== 'undefined') {
			innerPrivate.kmlLayer.setMap(null);
		}

		if (file_url !== '') {
			innerPrivate.kmlLayer = new google.maps.KmlLayer(file_url);
			innerPrivate.kmlLayer.setMap(innerPrivate.map);
		}
	};

	innerPrivate.closeInfoWindows = function () {
		if (innerPrivate.infowindow) {
			innerPrivate.infowindow.close();
		}
	};

	innerPrivate.getProblemHtml = function (item) {
		var content = '<div class="box_content">' +
    '<div class="project_title">' + item.title + '</div>' +
    '<div class="project_q_info">' +
    '<div class="q_left"><span class="meta_title">' + innerPrivate.getT('projectsmap_project_value') + ':</span><span class="meta_value"> ' + item.value + '</span></div>' +
    '<div class="q_right"><span class="meta_title">' + innerPrivate.getT('projectsmap_project_time') + ':</span><span class="meta_value"> ' + item.date_text + '</span></div>' +
    '<div class="q_status"><span class="meta_title">' + innerPrivate.getT('projectsmap_project_status') + ':</span><span class="meta_value"> ' + item.status_title + '</span></div>' +
    '</div>' +
    '<a href="'+item.view_url+'">' + innerPrivate.getT('more_info') + '</a>' +
    '</div>';
		return content;
	};

	innerPrivate.getT = function (key) {
		if (typeof (params.t[key]) === 'string') {
			return params.t[key];
		}
		return '*' + key + '*';
	};

	innerPrivate.formatDate = function (timestamp) {
		var d = new Date(timestamp * 1000);

		var hours = d.getHours();
		var month = "0" + (d.getMonth() + 1);
		var minutes = "0" + d.getMinutes();
		var seconds = "0" + d.getSeconds();

		// Will display time in 10:30:23 format
		return d.getFullYear() + '-' + month.substr(-2) + '-' + d.getDate() + ' ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
	};

	innerPrivate.init();
}

window.ProjectsMap = ProjectsMap;
